'use strict';

var $isNaN = require('./isNaN');

module.exports = function (x) { return (typeof x === 'number' || typeof x === 'bigint') && !$isNaN(x) && x !== Infinity && x !== -Infinity; };



// WEBPACK FOOTER //
// ./~/es-abstract/helpers/isFinite.js